'use client';

import { c as _c } from "react/compiler-runtime";
import { BasicTooltip } from '@/comps/basic-tooltip';
import { Skeleton } from '@/comps/primitives/skeleton';
import { cn } from '@/utils/shad';
import { onEnterPress } from '@/utils/keyboard.utils';
import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
type SidebarNavRowSkeletonProps = {
  buttonClassName?: string;
};
export function SidebarNavRowSkeleton(t0) {
  const $ = _c(5);
  const {
    buttonClassName
  } = t0;
  let t1;
  if ($[0] !== buttonClassName) {
    t1 = cn("flex h-7 w-full shrink-0 items-center px-2", buttonClassName);
    $[0] = buttonClassName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Skeleton className="h-5 w-full rounded-md" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <div aria-hidden={true} className={t1}>{t2}</div>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
type SidebarNavRowProps = {
  id: string;
  name: string;
  active: boolean;
  onClick: () => void;
  Icon: LucideIcon;
  buttonClassName?: string;
  iconClassName?: string;
  iconGap?: number;
  trailing?: ReactNode;
  testId?: string;
  dataAttributes?: Record<string, string>;
};
export function SidebarNavRow(t0) {
  const $ = _c(31);
  const {
    id,
    name,
    active,
    onClick,
    Icon,
    buttonClassName,
    iconClassName,
    iconGap: t1,
    trailing,
    testId: t2,
    dataAttributes
  } = t0;
  const iconGap = t1 === undefined ? 4 : t1;
  const testId = t2 === undefined ? "sidebar-nav-item" : t2;
  let t3;
  if ($[0] !== onClick) {
    t3 = event => onEnterPress(event, onClick);
    $[0] = onClick;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = active && "bg-accent/75 text-accent-foreground";
  let t5;
  if ($[2] !== buttonClassName || $[3] !== t4) {
    t5 = cn("group flex h-7 w-full cursor-pointer items-center rounded-md text-white hover:bg-accent hover:text-accent-foreground", t4, buttonClassName);
    $[2] = buttonClassName;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== iconGap) {
    t6 = {
      gap: iconGap
    };
    $[5] = iconGap;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== iconClassName) {
    t7 = cn("size-3 shrink-0", iconClassName);
    $[7] = iconClassName;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== Icon || $[10] !== t7) {
    t8 = <Icon className={t7} aria-hidden={true} />;
    $[9] = Icon;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== name) {
    t9 = <span className="min-w-0 flex-1 truncate text-left text-[13px] tracking-[-0.31px]">{name}</span>;
    $[12] = name;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== name || $[15] !== t9) {
    t10 = <BasicTooltip text={name} side="right">{t9}</BasicTooltip>;
    $[14] = name;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== trailing) {
    t11 = trailing ? <div className="flex shrink-0 items-center justify-end" onClick={_temp} onPointerDown={_temp2} onKeyDown={_temp3}>{trailing}</div> : null;
    $[17] = trailing;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== dataAttributes || $[20] !== id || $[21] !== name || $[22] !== onClick || $[23] !== t10 || $[24] !== t11 || $[25] !== t3 || $[26] !== t5 || $[27] !== t6 || $[28] !== t8 || $[29] !== testId) {
    t12 = <div role="button" tabIndex={0} onClick={onClick} onKeyDown={t3} data-testid={testId} data-nav-id={id} data-nav-name={name} {...dataAttributes} className={t5} style={t6}>{t8}{t10}{t11}</div>;
    $[19] = dataAttributes;
    $[20] = id;
    $[21] = name;
    $[22] = onClick;
    $[23] = t10;
    $[24] = t11;
    $[25] = t3;
    $[26] = t5;
    $[27] = t6;
    $[28] = t8;
    $[29] = testId;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  return t12;
}
function _temp3(e_1) {
  return e_1.stopPropagation();
}
function _temp2(e_0) {
  return e_0.stopPropagation();
}
function _temp(e) {
  return e.stopPropagation();
}